import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useParams } from 'react-router-dom';
import { Sidebar } from '../components/dashboard/Sidebar';
import { PromptBox } from '../components/dashboard/PromptBox';
import { Image, Video, FileText, Play, Download, MoreHorizontal, Clock } from 'lucide-react';
type Platform = 'facebook' | 'google' | 'instagram' | 'linkedin';
type GeneratorType = 'imagenes' | 'videos' | 'copys';
// Platform icons
const platformIcons: Record<Platform, React.ReactNode> = {
  facebook: <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-299">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-300" />
    </svg>,
  google: <svg className="w-5 h-5" viewBox="0 0 24 24" data-id="element-301">
      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" data-id="element-302" />
      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-303" />
      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-304" />
      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-305" />
    </svg>,
  instagram: <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-306">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" data-id="element-307" />
    </svg>,
  linkedin: <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-308">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" data-id="element-309" />
    </svg>
};
// Sample images
const sampleImages = ['https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=400&h=400&fit=crop', 'https://images.unsplash.com/photo-1611162616305-c69b3fa7fbe0?w=400&h=400&fit=crop', 'https://images.unsplash.com/photo-1611162618071-b39a2ec055fb?w=400&h=400&fit=crop', 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=400&h=400&fit=crop', 'https://images.unsplash.com/photo-1432888622747-4eb9a8efeb07?w=400&h=400&fit=crop', 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=400&fit=crop', 'https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?w=400&h=400&fit=crop', 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=400&fit=crop', 'https://images.unsplash.com/photo-1533750349088-cd871a92f312?w=400&h=400&fit=crop', 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=400&h=400&fit=crop', 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=400&h=400&fit=crop', 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=400&h=400&fit=crop'];
// Sample videos
const sampleVideos = [{
  id: 1,
  title: 'Video promocional Q1',
  duration: '0:45',
  thumbnail: 'https://images.unsplash.com/photo-1536240478700-b869070f9279?w=600&h=340&fit=crop',
  date: 'Hace 2 días'
}, {
  id: 2,
  title: 'Testimonial cliente',
  duration: '1:20',
  thumbnail: 'https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?w=600&h=340&fit=crop',
  date: 'Hace 5 días'
}, {
  id: 3,
  title: 'Demo producto nuevo',
  duration: '2:15',
  thumbnail: 'https://images.unsplash.com/photo-1492619375914-88005aa9e8fb?w=600&h=340&fit=crop',
  date: 'Hace 1 semana'
}];
// Sample copys
const sampleCopys = [{
  id: 1,
  title: 'Copy para Facebook - Promoción',
  content: '🔥 ¡Oferta especial! Solo por tiempo limitado, obtén un 30% de descuento en todos nuestros productos. No dejes pasar esta oportunidad única. ¡Compra ahora y ahorra! #Oferta #Descuento #CompraYa',
  date: 'Hace 1 hora'
}, {
  id: 2,
  title: 'Copy para LinkedIn - B2B',
  content: '¿Buscas optimizar los procesos de tu empresa? Nuestra solución ha ayudado a más de 500 empresas a aumentar su productividad en un 40%. Agenda una demo gratuita y descubre cómo podemos ayudarte.',
  date: 'Hace 3 horas'
}, {
  id: 3,
  title: 'Copy para Instagram - Engagement',
  content: '✨ Nuevo lanzamiento ✨\n\nEstamos emocionados de presentar nuestra nueva colección. Diseñada pensando en ti, con materiales premium y atención al detalle.\n\n¿Cuál es tu favorito? 👇\n\n#NuevaColección #Moda #Estilo',
  date: 'Hace 1 día'
}];
export function ProjectEditorPage() {
  const {
    projectId
  } = useParams();
  const [selectedPlatform, setSelectedPlatform] = useState<Platform>('facebook');
  const [selectedGenerator, setSelectedGenerator] = useState<GeneratorType>('imagenes');
  const platforms: {
    id: Platform;
    label: string;
  }[] = [{
    id: 'facebook',
    label: 'Facebook Ads'
  }, {
    id: 'google',
    label: 'Google Ads'
  }, {
    id: 'instagram',
    label: 'Instagram'
  }, {
    id: 'linkedin',
    label: 'LinkedIn'
  }];
  const generators: {
    id: GeneratorType;
    label: string;
    icon: React.ReactNode;
  }[] = [{
    id: 'imagenes',
    label: 'Imágenes',
    icon: <Image className="w-4 h-4" data-id="element-310" />
  }, {
    id: 'videos',
    label: 'Videos',
    icon: <Video className="w-4 h-4" data-id="element-311" />
  }, {
    id: 'copys',
    label: "Copy's",
    icon: <FileText className="w-4 h-4" data-id="element-312" />
  }];
  const handlePromptSubmit = (prompt: string) => {
    console.log('Generating:', selectedGenerator, 'for', selectedPlatform, 'with prompt:', prompt);
  };
  return <div className="min-h-screen bg-gray-50 flex" data-id="element-313">
      <Sidebar data-id="element-314" />

      <main className="flex-1 md:ml-64 p-6 md:p-8" data-id="element-315">
        <div className="max-w-6xl mx-auto space-y-6" data-id="element-316">
          {/* Header with platform and generator selection */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4" data-id="element-317">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4" data-id="element-318">
              {/* Platform Selection - Left */}
              <div className="flex items-center gap-2" data-id="element-319">
                {platforms.map(platform => <button key={platform.id} onClick={() => setSelectedPlatform(platform.id)} className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium transition-all ${selectedPlatform === platform.id ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`} data-id="element-320">
                    <span className={selectedPlatform === platform.id ? 'text-white' : ''} data-id="element-321">
                      {platformIcons[platform.id]}
                    </span>
                    <span className="hidden sm:inline" data-id="element-322">{platform.label}</span>
                  </button>)}
              </div>

              {/* Generator Selection - Right */}
              <div className="flex items-center gap-4" data-id="element-323">
                <span className="text-sm font-semibold text-gray-700" data-id="element-324">
                  Generar:
                </span>
                <div className="flex items-center gap-2" data-id="element-325">
                  {generators.map(gen => <button key={gen.id} onClick={() => setSelectedGenerator(gen.id)} className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium transition-all ${selectedGenerator === gen.id ? 'bg-gradient-to-r from-orange-500 to-pink-500 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`} data-id="element-326">
                      {gen.icon}
                      {gen.label}
                    </button>)}
                </div>
              </div>
            </div>
          </div>

          {/* Prompt Box */}
          <PromptBox placeholder={selectedGenerator === 'imagenes' ? 'Describe la imagen que quieres generar para tu campaña...' : selectedGenerator === 'videos' ? 'Describe el video que quieres crear...' : 'Describe el copy que necesitas para tu anuncio...'} onSubmit={handlePromptSubmit} data-id="element-327" />

          {/* Content Area */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6" data-id="element-328">
            <h2 className="text-lg font-bold text-gray-900 mb-6" data-id="element-329">
              {selectedGenerator === 'imagenes' && 'Imágenes Recientes'}
              {selectedGenerator === 'videos' && 'Videos Recientes'}
              {selectedGenerator === 'copys' && "Copy's Recientes"}
            </h2>

            {/* Images Grid */}
            {selectedGenerator === 'imagenes' && <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-330">
                {sampleImages.map((img, index) => <motion.div key={index} initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              delay: index * 0.05
            }} className="group relative aspect-square rounded-xl overflow-hidden cursor-pointer" data-id="element-331">
                    <img src={img} alt={`Generated ${index + 1}`} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110" data-id="element-332" />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100" data-id="element-333">
                      <div className="flex items-center gap-2" data-id="element-334">
                        <button className="p-2 bg-white rounded-lg hover:bg-gray-100 transition-colors" data-id="element-335">
                          <Download className="w-4 h-4 text-gray-700" data-id="element-336" />
                        </button>
                        <button className="p-2 bg-white rounded-lg hover:bg-gray-100 transition-colors" data-id="element-337">
                          <MoreHorizontal className="w-4 h-4 text-gray-700" data-id="element-338" />
                        </button>
                      </div>
                    </div>
                  </motion.div>)}
              </div>}

            {/* Videos List */}
            {selectedGenerator === 'videos' && <div className="space-y-4" data-id="element-339">
                {sampleVideos.map((video, index) => <motion.div key={video.id} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: index * 0.1
            }} className="group flex gap-4 p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors cursor-pointer" data-id="element-340">
                    <div className="relative w-48 h-28 rounded-lg overflow-hidden flex-shrink-0" data-id="element-341">
                      <img src={video.thumbnail} alt={video.title} className="w-full h-full object-cover" data-id="element-342" />
                      <div className="absolute inset-0 flex items-center justify-center bg-black/30" data-id="element-343">
                        <div className="w-10 h-10 rounded-full bg-white/90 flex items-center justify-center" data-id="element-344">
                          <Play className="w-5 h-5 text-gray-900 ml-0.5" data-id="element-345" />
                        </div>
                      </div>
                      <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 rounded text-xs text-white" data-id="element-346">
                        {video.duration}
                      </div>
                    </div>
                    <div className="flex-1" data-id="element-347">
                      <h3 className="font-semibold text-gray-900 mb-1" data-id="element-348">
                        {video.title}
                      </h3>
                      <div className="flex items-center gap-1 text-sm text-gray-500" data-id="element-349">
                        <Clock className="w-4 h-4" data-id="element-350" />
                        {video.date}
                      </div>
                    </div>
                    <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-351">
                      <button className="p-2 bg-white rounded-lg hover:bg-gray-200 transition-colors shadow-sm" data-id="element-352">
                        <Download className="w-4 h-4 text-gray-700" data-id="element-353" />
                      </button>
                      <button className="p-2 bg-white rounded-lg hover:bg-gray-200 transition-colors shadow-sm" data-id="element-354">
                        <MoreHorizontal className="w-4 h-4 text-gray-700" data-id="element-355" />
                      </button>
                    </div>
                  </motion.div>)}
              </div>}

            {/* Copys List */}
            {selectedGenerator === 'copys' && <div className="space-y-4" data-id="element-356">
                {sampleCopys.map((copy, index) => <motion.div key={copy.id} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: index * 0.1
            }} className="group p-5 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors" data-id="element-357">
                    <div className="flex items-start justify-between mb-3" data-id="element-358">
                      <h3 className="font-semibold text-gray-900" data-id="element-359">
                        {copy.title}
                      </h3>
                      <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-360">
                        <button className="p-2 bg-white rounded-lg hover:bg-gray-200 transition-colors shadow-sm" data-id="element-361">
                          <Download className="w-4 h-4 text-gray-700" data-id="element-362" />
                        </button>
                        <button className="p-2 bg-white rounded-lg hover:bg-gray-200 transition-colors shadow-sm" data-id="element-363">
                          <MoreHorizontal className="w-4 h-4 text-gray-700" data-id="element-364" />
                        </button>
                      </div>
                    </div>
                    <p className="text-gray-700 whitespace-pre-line mb-3" data-id="element-365">
                      {copy.content}
                    </p>
                    <div className="flex items-center gap-1 text-sm text-gray-500" data-id="element-366">
                      <Clock className="w-4 h-4" data-id="element-367" />
                      {copy.date}
                    </div>
                  </motion.div>)}
              </div>}
          </div>
        </div>
      </main>
    </div>;
}